var _mask, _g, _mask2, _g2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHalfStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 8,
    width: 80,
    height: 76
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.8042 11.7082C52.6068 8.02295 47.3932 8.02296 46.1958 11.7082L39.6724 31.7852C39.1369 33.4333 37.601 34.5491 35.8681 34.5491H14.7579C10.883 34.5491 9.27191 39.5076 12.4068 41.7852L29.4853 54.1935C30.8872 55.2121 31.4739 57.0175 30.9384 58.6656L24.415 78.7427C23.2175 82.4279 27.4355 85.4924 30.5703 83.2148L47.6489 70.8065C49.0508 69.7879 50.9492 69.7879 52.3511 70.8065L69.4297 83.2148C72.5645 85.4924 76.7824 82.4279 75.585 78.7426L69.0616 58.6656C68.5261 57.0175 69.1128 55.2121 70.5147 54.1935L87.5932 41.7852C90.7281 39.5076 89.117 34.5491 85.2421 34.5491H64.1319C62.399 34.5491 60.8631 33.4333 60.3276 31.7852L53.8042 11.7082Z",
    fill: "#D1DCE0"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 50,
    width: 100,
    height: 100,
    fill: "#D1DCE0"
  }))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 8,
    width: 80,
    height: 76
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.8042 11.7082C52.6068 8.02295 47.3932 8.02296 46.1958 11.7082L39.6724 31.7852C39.1369 33.4333 37.601 34.5491 35.8681 34.5491H14.7579C10.883 34.5491 9.27191 39.5076 12.4068 41.7852L29.4853 54.1935C30.8872 55.2121 31.4739 57.0175 30.9384 58.6656L24.415 78.7427C23.2175 82.4279 27.4355 85.4924 30.5703 83.2148L47.6489 70.8065C49.0508 69.7879 50.9492 69.7879 52.3511 70.8065L69.4297 83.2148C72.5645 85.4924 76.7824 82.4279 75.585 78.7426L69.0616 58.6656C68.5261 57.0175 69.1128 55.2121 70.5147 54.1935L87.5932 41.7852C90.7281 39.5076 89.117 34.5491 85.2421 34.5491H64.1319C62.399 34.5491 60.8631 33.4333 60.3276 31.7852L53.8042 11.7082Z",
    fill: "#FED426"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    transform: "matrix(-1 0 0 1 50 0)",
    fill: "#FED426"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHalfStar);
export default __webpack_public_path__ + "static/media/HalfStar.7b64f321.svg";
export { ForwardRef as ReactComponent };